import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["contentIds", "audience", "teams"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React from 'react';
import { getCommonTeams } from '../utils';
import OwningTeamField from '.';
import { jsx as _jsx } from "react/jsx-runtime";
export function PlaylistOwningTeamField(_ref) {
  var _ref$contentIds = _ref.contentIds,
    contentIds = _ref$contentIds === void 0 ? [] : _ref$contentIds,
    audience = _ref.audience,
    teams = _ref.teams,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var isMultiSelect = (contentIds === null || contentIds === void 0 ? void 0 : contentIds.length) > 1;
  var commonTeams = isMultiSelect ? getCommonTeams(teams.filter(function (team) {
    return team.length > 0;
  })) : teams[0];
  var selectableTeamIds = [];
  if (audience === 'all') {
    selectableTeamIds = undefined; // All available teams in the hub can be selected as potential owners
  } else if (audience === 'teams' || audience === 'mixed') {
    selectableTeamIds = commonTeams === null || commonTeams === void 0 ? void 0 : commonTeams.filter(function (team) {
      return !(team !== null && team !== void 0 && team.isCalculated);
    }).map(function (team) {
      return team.id;
    });
  }
  return /*#__PURE__*/_jsx(OwningTeamField, _objectSpread({
    contentType: "playlist",
    selectableTeamIds: selectableTeamIds,
    contentIds: contentIds
  }, otherProps));
}
export default PlaylistOwningTeamField;